// react
import React, { useEffect } from "react";

// MATERIAL-UI
import { Button, Grid, Dialog, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

// COMPONENTS
import FilterModal from "./FilterModal";

// ASSESTS
import { FilterStyles } from "./styles/Filter.styles";
import { FilterProps } from "./types";
import GA from "src/analytics/googleAnalytics";
import { useAppDispatch } from "src/store/store";
import { setMarketSector } from "src/store/features/markets.slice";
import { trackEvent } from "src/Amplitude";

const Filter = (props: FilterProps) => {
  const { defaultValue } = props;
  const classes = FilterStyles();
  const dispatch = useAppDispatch();

  const [value, setValue] = React.useState(defaultValue);
  const [open, setOpen] = React.useState<boolean>(false);

  const handleSetValue = async (sector: string) => {
    setValue(sector || "Sectors");
    handleOpenToggle();
    dispatch(setMarketSector(sector));
    GA.filterSelection(sector);
  };

  const handleOpenToggle = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    return () => {
      dispatch(setMarketSector(""));
    };
  }, []);

  return (
    <Grid container className={classes.container}>
      <Grid
        item
        xs
        onClick={() =>
          trackEvent("Select_Markets_Page", {
            option: "Select_Sector",
          })
        }>
        <Button
          disableRipple
          variant="outlined"
          sx={{ borderRadius: 3 }}
          endIcon={<FilterListIcon style={{ fontSize: "24px" }} />}
          className={classes.button}
          onClick={handleOpenToggle}>
          <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>{value}</Typography>
        </Button>
        {open && (
          <Dialog open={open} onClose={handleOpenToggle}>
            <FilterModal title="Sectors" setValue={handleSetValue} onClose={handleOpenToggle} />
          </Dialog>
        )}
      </Grid>
    </Grid>
  );
};

export default Filter;
